import React, { useContext, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { useTheme } from "@material-ui/styles";
import { ANIMATIONS } from "../config";

const WaitingMessage = ({ loadingMessage }) => {
  return (
    <>
      <Grid
        item
        className={"fade-in-anim"}
        style={{
          height: "0",
          paddingInline: "1rem",
          marginTop: "20px",
          marginBottom: "-20px",
        }}
      >
        <Typography variant="body2" color="textSecondary">
          {loadingMessage}
        </Typography>
      </Grid>
    </>
  );
};

export default function FlowLoadingWindowManager() {
  const {
    state: { flowLoading, currentSection, processCriticalError, flowMessage },
    dispatch,
  } = useContext(ProcessContext);

  const {
    show: flowLoadingContextShow,
    animationId,
    loadingMessage,
  } = flowLoading;

  const { palette, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const [state, setState] = React.useState({
    forceDisplayLoading: false,
  });
  const { forceDisplayLoading } = state;
  const fadeTime = 500;
  const flowLoadingOrMessage = flowLoadingContextShow || flowMessage?.id;
  const loading = processCriticalError ? false : flowLoadingOrMessage;
  useEffect(() => {
    if (!loading) {
      setState({ forceDisplayLoading: true });
      setTimeout(() => resetFlowLoading(), fadeTime);
    }
  }, [currentSection, loading]);

  useEffect(() => {
    if (loading) {
      setState({ forceDisplayLoading: true });
    }
  }, [loading]);

  const resetFlowLoading = () => {
    setState({ forceDisplayLoading: false });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: {
        show: false,
        animationId: undefined,
        loadingMessage: undefined,
      },
    });
  };

  const showFlowLoading = loading || forceDisplayLoading;
  const fadeLoading = !loading && forceDisplayLoading;
  const hidingUnderneathShadowClassConditions = isScreenXs
    ? "hiding-underneath-shadow"
    : "";
  const animationTypeClassConditions = fadeLoading
    ? "disappear-anim"
    : "appear-anim";
  const flowLoadingClassName = `${hidingUnderneathShadowClassConditions} ${animationTypeClassConditions}`;

  return (
    <>
      {showFlowLoading && (
        <Box
          zIndex={"modal"}
          className={flowLoadingClassName}
          width={"100%"}
          height={"100%"}
          left={0}
          top={0}
          position={"absolute"}
          display={"flex"}
        >
          <Paper elevation={0} className={"w-100 text-center"}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              className={"h-100"}
            >
              <Grid item>
                {!animationId ? (
                  <>
                    <CircularProgress
                      aria-label="loading application"
                      className={"transition-all"}
                      size={fadeLoading ? 110 : 100}
                      thickness={1.5}
                      style={{
                        margin: "-20px 0 0 0",
                        color: fadeLoading
                          ? palette.success.main
                          : palette.secondary.main,
                      }}
                    />
                    {loadingMessage && (
                      <WaitingMessage loadingMessage={loadingMessage} />
                    )}
                  </>
                ) : (
                  <Container
                    maxWidth="xs"
                    style={{
                      minHeight: "100%",
                      paddingLeft: isScreenXs ? "1rem" : "2rem",
                      paddingRight: isScreenXs ? "1rem" : "2rem",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                      paddingBottom: "70px",
                    }}
                  >
                    <Box className="appear-anim">
                      <img
                        alt={"Waiting animation image"}
                        src={ANIMATIONS[animationId.id].src}
                        height={isScreenXs ? "150px" : "180px"}
                        style={{ margin: "0 auto" }}
                      />
                      {loadingMessage && (
                        <WaitingMessage loadingMessage={loadingMessage} />
                      )}
                    </Box>
                  </Container>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Box>
      )}
    </>
  );
}
